<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "DatatableV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "datatableColumns",
          properties: {
            label: "Columns"
          },
          property: "columns"
        },
        {
          type: "tableData",
          properties: {
            label: "Default Values"
          },
          property: "value"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
